<template>
  <section class="credits h7 nimbus-sans underline-links">
    <h6 class="no-case"><a @click="creditsVisible = !creditsVisible">Credits</a></h6>
    <p v-show="creditsVisible">
      Design & Art Direction by <a href="http://spencerfenton.co.uk/" target="_blank" rel="noopener">Spencer Fenton</a><br>
      Photography by Chloe Tun Tun<br>
      Programming by <a href="http://everettwilliams.info" target="_blank" rel="noopener">Everett Williams</a><br>
      VR images by <a href="http://www.universalassemblyunit.com" target="_blank" rel="noopener">Universal Assembly Unit</a>
    </p>
  </section>
</template>

<script>
export default {
  name: 'Credits',
  data () {
    return {
      creditsVisible: false
    }
  }
}
</script>

<style lang="scss" scoped>
.credits {
  margin-top: 5em;
  h6{
    margin-bottom: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// Credits.vue?2d4bb113